module.exports={render:function (){with(this) {
  return _h('span', {
    class: classes
  }, [(isMoney) ? _h('input', {
    directives: [{
      name: "model",
      value: (val),
      expression: "val",
      modifiers: {
        "trim": true
      }
    }],
    ref: "input",
    attrs: {
      "id": id,
      "size": String(val).length || 1
    },
    domProps: {
      "value": _s(val)
    },
    on: {
      "keyup": function($event) {
        if ($event.keyCode !== 13) return;
        blur()
      },
      "blur": function($event) {
        onBlur()
      },
      "input": function($event) {
        if ($event.target.composing) return;
        val = $event.target.value.trim()
      }
    }
  }) : _e(), " ", (isNumber) ? _h('input', {
    directives: [{
      name: "model",
      value: (val),
      expression: "val",
      modifiers: {
        "number": true,
        "trim": true
      }
    }],
    ref: "input",
    attrs: {
      "id": id,
      "size": String(val).length || 1
    },
    domProps: {
      "value": _s(val)
    },
    on: {
      "keyup": function($event) {
        if ($event.keyCode !== 13) return;
        blur()
      },
      "blur": function($event) {
        onBlur()
      },
      "input": function($event) {
        if ($event.target.composing) return;
        val = _n($event.target.value.trim())
      }
    }
  }) : _e(), " ", (isMultiline) ? _h('textarea', {
    directives: [{
      name: "model",
      value: (val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "id": id,
      "rows": val.split('\n').length || 1
    },
    domProps: {
      "value": _s(val)
    },
    on: {
      "blur": function($event) {
        onBlur()
      },
      "input": function($event) {
        if ($event.target.composing) return;
        val = $event.target.value
      }
    }
  }) : _e(), " ", (!isNumber && !isMoney && !isMultiline) ? _h('input', {
    directives: [{
      name: "model",
      value: (val),
      expression: "val",
      modifiers: {
        "trim": true
      }
    }],
    ref: "input",
    attrs: {
      "id": id,
      "size": val.length || 1
    },
    domProps: {
      "value": _s(val)
    },
    on: {
      "keyup": function($event) {
        if ($event.keyCode !== 13) return;
        blur()
      },
      "blur": function($event) {
        onBlur()
      },
      "input": function($event) {
        if ($event.target.composing) return;
        val = $event.target.value.trim()
      }
    }
  }) : _e(), " ", _h('label', {
    attrs: {
      "for": id
    }
  }, [_s(val)]), (isDate) ? _h('span', {
    ref: "container"
  }) : _e()])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editable.vue
 ** module id = 170
 ** module chunks = 2
 **/